import React, { useState } from "react";
import "./styles.css";
import { BurgerMenuSVG, CloseSVG } from "../../../constants/svgs";
import { Link } from "react-router-dom";
import { COLORS } from "../../../constants/texts";
import LanguageSwitch from "../lang_switch/LanguageSwitch";
import { useI18n } from "../../../i18n/i18n";

interface Props {
    color: string;
    logoColor?: string;
    burgerColor?: string;
    isVisible?: boolean;
}

const Header: React.FC<Props> = ({
    color,
    logoColor = COLORS.BLACK,
    burgerColor = COLORS.BLACK,
    isVisible = true,
}) => {
    const { t } = useI18n();
    const path = window.location.href.split("/").pop() || "inicio";
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <div className={`header fade-in ${isVisible ? "" : "header--hidden"}`}>
            <div className="header-body w100">
                <div />
                <div className={`header-points fw700`} data-color={COLORS.GRAY}>
                    <Link to="/inicio" style={{ color: path === "inicio" ? COLORS.WHITE : COLORS.GRAY }}>
                        {t("nav.home")}
                    </Link>

                    <Link to="/movie" style={{ color: path === "movie" ? COLORS.WHITE : COLORS.GRAY }}>
                        {t("nav.film")}
                    </Link>

                    <Link to="/project" style={{ color: path === "project" ? COLORS.WHITE : COLORS.GRAY }}>
                        {t("nav.play")}
                    </Link>

                    <Link to="/schedule" style={{ color: path === "schedule" ? COLORS.WHITE : COLORS.GRAY }}>
                        {t("nav.upcomingDates")}
                    </Link>

                    <Link to="/various" style={{ color: path === "various" ? COLORS.WHITE : COLORS.GRAY }}>
                        {t("nav.others")}
                    </Link>

                    <LanguageSwitch />
                </div>

                <div className="burger-menu d-flex aic jce gap">
                    <LanguageSwitch />
                    <div onClick={() => setIsOpen(true)}>
                        <BurgerMenuSVG color={COLORS.WHITE} />
                    </div>
                </div>

                {isOpen && (
                    <div className="burger-menu-opened">
                        <div className="header-opened-header d-flex flex-row jcsb aie">
                            <div />
                            <div onClick={() => setIsOpen(false)} style={{ height: 24 }}>
                                <CloseSVG />
                            </div>
                        </div>
                        <div style={{ minHeight: 61 }} />
                        <div>
                            <div className="open-menu-title">
                                <Link to="/inicio" style={{ color: COLORS.WHITE }}>
                                    {t("nav.home")}
                                </Link>
                            </div>
                            <div className="open-menu-title">
                                <Link to="/movie" style={{ color: COLORS.WHITE }}>
                                    {t("nav.film")}
                                </Link>
                            </div>
                            <div className="open-menu-title">
                                <Link to="/project" style={{ color: COLORS.WHITE }}>
                                    {t("nav.play")}
                                </Link>
                            </div>
                            <div className="open-menu-title">
                                <Link to="/schedule" style={{ color: COLORS.WHITE }}>
                                    {t("nav.upcomingDates")}
                                </Link>
                            </div>
                            <div className="open-menu-title">
                                <Link to="/various" style={{ color: COLORS.WHITE }}>
                                    {t("nav.others")}
                                </Link>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Header;
